module.exports = __webpack_public_path__ + "static/media/refund.f87e80e5.svg";